/** @file 问卷 语言配置 */
const zhCN = {
  questionnaire: {
    back: '返回',
    cancel: '取消',
    confirm: '确认',
    fillHandler: '立即填写',
    publishing: '发布中',
    netError: '网络已断开，请刷新重试',
    requiredTip: '请完成必填后重试',
    privacyTip: '请勾选同意后重试',
    title: '问卷',
    multiple: '多选',
    submit: '提交',
    submitSuccess: '提交成功',
    submitFail: '提交失败',
    endTips: '问卷已结束',
    submittedTips: '已答题',
    points: '分',
    list: '问卷列表',
    result: {
      title: '问卷结果'
    },
    know: '我知道了',
    singleChoice: '【单选】',
    multiChoice: '【多选】',
    askQuestion: '【问答】',
    evaluate: '【评价】',
    judgement: '【判断】',
    networkError: '网络错误',
    correctAnswer: '正确答案',
    result1: '选',
    result2: '的有',
    result3: '人 ，',
    result4: '占比 ',
    result5: '',
    total: '共有',
    total1: '人回答。',
    total2: '人评星。',
    total3: '人打分。',

    nicknameLabel: '昵称',
    rankLabel: '排名',
    costTimeLabel: '耗时',
    scoreLabel: '总得分',

    rankResultTip: '收到排行榜单, 点击查看',
    resultTip: '收到问卷结果, 点击查看',

    delayTimeTip: '距离考试结束还剩',
    totalScoreLabel: '总分数',
    scoreUnit: '分',
    hours: '时',
    minutes: '分',
    second: '秒',
    countdownEndTip: '考试倒计时结束， 已自动结束考试',
    knowBtn: '我知道了',
    mustChooseOne: '请选择其中一项，再进入下一题',
    finishAnswerThenSubmit: '请回答完所有题目再进行提交'
  },
};

const en = {
  questionnaire: {
    cancel: 'Cancel',
    confirm: 'Confirm',
    back: 'Back',
    fillHandler: 'Write',
    publishing: 'Publishing in progress',
    netError: 'Network Error',
    requiredTip: 'Complete the required fields and try again',
    privacyTip: 'Please check Agree and try again',
    title: 'Questionnaire',
    multiple: 'Multiple answer',
    submit: 'Submit',
    submitSuccess: 'Success',
    submitFail: 'Failed',
    points: 'points',
    list: 'list',
    result: {
      title: 'Questionnaire Result'
    },
    know: 'OK',
    singleChoice: '【Single Choice】',
    multiChoice: '【Multiple Choice】',
    askQuestion: '【Question】',
    evaluate: '【Evaluation】',
    judgement: '【Judgement】',
    networkError: 'Network Error',
    correctAnswer: 'Correct answer',
    result1: '',
    result2: ' was chosen by ',
    result3: 'people',
    result4: '(',
    result5: ')',
    total: '',
    total1: ' people answered.',
    total2: ' people evaluated.',
    total3: ' people evaluated.',

    nicknameLabel: 'Nickname',
    rankLabel: 'Ranking',
    costTimeLabel: 'Total time spent',
    scoreLabel: 'Score',

    rankResultTip: 'Receive the ranking, click to view',
    resultTip: 'Receive the result, click to view',

    scoreUnit: 'points',
    totalScoreLabel: 'Total score',
    endTips: 'The answer is over',
    submittedTips: 'Answered questions',
    delayTimeTip: 'There is still time left before the end of the exam',
    hours: 'h',
    minutes: 'm',
    second: 's',
    countdownEndTip: 'The exam countdown is over and the exam has been automatically closed',
    knowBtn: 'OK',
    mustChooseOne: 'Please select one option before proceeding to the next question',
    finishAnswerThenSubmit: 'Please answer all the questions before submitting'
  },
};

export default {
  zh_CN: zhCN,
  en,
};
